export const PhotoEditModalId = 'photo-edit-modal';
